module.exports = __webpack_public_path__ + "static/media/radio-btn-active.e75d7765.svg";